import cn from 'classnames'
import styles from './MaterialIcon.module.scss'
import { useTheme } from '../ThemeProvider/ThemeProvider'

const MaterialIcon = ({
  style = {},
  name,
  className,
  outlined,
  variant = 'none',
  ...props
}) => {
  const { themeMode } = useTheme() || {}

  // cn drops missing module classes (there is no .light), once rendered as "undefined".
  return (
    <span
      className={cn(`material-icons${outlined ? '-outlined' : ''}`, 'notranslate', className, styles[variant], styles[themeMode])}
      style={{ ...style }}
      {...props}
    >
      {name}
    </span>
  )
}

export default MaterialIcon
